// Shared pieces of the contact request pages: the roles and statuses, and the status badge (always a word, never colour alone).
import { useTranslation } from 'react-i18next';
import { Badge, type Tone } from '../../components/ui';
import type { ContactRole, ContactStatus } from '../../types/api';

export const CONTACT_ROLES: ContactRole[] = ['modeller', 'lender', 'investor', 'advisor', 'other'];
export const CONTACT_STATUSES: ContactStatus[] = ['new', 'in_progress', 'done', 'spam'];

function statusTone(status: ContactStatus): Tone {
  return status === 'new' ? 'accent' : status === 'in_progress' ? 'warn' : status === 'done' ? 'good' : 'neutral';
}

export function ContactStatusBadge({ status }: { status: ContactStatus }) {
  const { t } = useTranslation();
  return <Badge tone={statusTone(status)}>{t(`contact.status.${status}`, status)}</Badge>;
}
